export const Logo = ({ size = "md", onClick, className = "" }) => {
  const sizes = {
    sm: "h-10 sm:h-11",
    md: "h-12 sm:h-14",
    lg: "h-24 sm:h-32",
    xl: "h-44 sm:h-60 md:h-72",
  }[size];
  return (
    <img
      src="/logo.png"
      alt="Conexão Inefável"
      onClick={onClick}
      data-testid="logo-brand"
      className={`${sizes} w-auto select-none ${onClick ? "cursor-pointer" : ""} ${className}`}
      style={{ mixBlendMode: "screen" }}
      draggable="false"
    />
  );
};
